export enum NatureOfAccountEnum {
  'Income' = 1,
  'Cost of Sales',
  'Expenses',
  'Current Assets',
  'Current Liabilities',
  'Long Term Assets',
  'Long Term Liabilities',
  'Owners Equity'
}

export namespace NatureOfAccountEnum {
  export function values() {
    return Object.keys(NatureOfAccountEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
